<!--
 * @Author: xuchen
 * @Date: 2020-03-10 14:19:37
 * @Desc: 企业视频远程巡查
 -->
<template>
  <h-page-container v-loading="loading">
    <h-page-content class="enterprise-content-container J-enterprise-content-container">
      <separate :size="hasSearched ? 80 : 128" />
      <!-- 检索栏 -->
      <search-bar
        :tags="enterpriseFilterTags"
        :region-data="regionData"
        @searchList="handleSearchList"
      />
      <separate v-show="hasSearched" size="48" />
      <!-- 企业列表 -->
      <enterprise-list
        v-show="hasSearched"
        :data-provider="enterpriseList"
        :total="pagination.total"
        @selectEnterprise="handleSelectEnterprise"
        @getMoreData="getMoreData"
      />
      <!-- 企业监控弹窗 -->
      <video-dialog
        :visible.sync="showDialog"
        :default-selected-enterp-key="selectedEnterpriseKey"
        :enterprise-list="enterpriseList"
        @getMoreEnterpriseData="getMoreData"
      />
      <scroll-to-top target=".J-enterprise-content-container" />
    </h-page-content>
  </h-page-container>
</template>

<script>
import SearchBar from '@/components/EnterpriseVideoInspection/SearchBar.vue'
import EnterpriseList from '@/components/EnterpriseVideoInspection/EnterpriseList'
import VideoDialog from '@/components/EnterpriseVideoInspection/VideoDialog.vue'
import http from '@/api/enterpriseVideoInspection'
import Separate from '@/components/Separate/Separate'
import ScrollToTop from '@/components/ScrollToTop'

export default {
  name: 'EnterpriseVideoInspection',
  components: {
    SearchBar,
    EnterpriseList,
    VideoDialog,
    Separate,
    ScrollToTop
  },
  data() {
    return {
      loading: false,
      hasSearched: true, // 是否查询过
      enterpriseList: [], // 企业列表
      pagination: {
        total: 0,
        pageSize: 100,
        pageNo: 1
      },
      showDialog: false, // 显示详情弹窗
      selectedEnterpriseKey: '', // 选中的企业主键
      enterpriseProperty: {
        labelType: '企业性质',
        labelCode: 'enterprisePropertyList',
        list: []
      }, // 企业类型
      industry: {
        labelType: '行业分类',
        labelCode: 'industryIdList',
        list: []
      }, // 企业性质
      regionData: [] // 区域数据
    }
  },
  computed: {
    enterpriseFilterTags() {
      return [this.enterpriseProperty, this.industry]
    }
  },
  watch: {
    showDialog(value) {
      // 关闭弹窗时要重置选择的
      if (!value) {
        this.selectedEnterpriseKey = ''
        this.handleSearchList(this.searchParams)
      }
    }
  },
  created() {
    this.queryDutyRegion()
    this.getEnterpriseConditions()
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-10 16:05:12
     * @desc 检索列表
     */
    handleSearchList(params) {
      this.pagination.pageNo = 1
      this.searchParams = { ...params }
      this.getEnterpriseList()
    },

    /**
     * @author xuchen
     * @date 2020-03-17 17:22:12
     * @desc 获取企业列表的请求入口
     */
    async getEnterpriseList(isappend) {
      this.loading = true
      const payload = {
        ...this.searchParams,
        ...this.pagination,
        projectCode: this.$store.state.projectCode
      }
      const { data } = await http.getEnterpriseList(payload)
      this.pagination.total = data.total
      this.enterpriseList = isappend ? this.enterpriseList.concat(data.rows) : data.rows
      this.hasSearched = true
      this.loading = false
    },

    /**
     * @author xuchen
     * @date 2020-03-10 16:55:54
     * @desc 选择企业，查看详情
     */
    handleSelectEnterprise(key) {
      this.showDialog = true
      this.selectedEnterpriseKey = key
    },

    /**
     * @author xuchen
     * @date 2020-03-17 17:17:50
     * @desc 获取更多列表
     */
    getMoreData() {
      const { pageNo } = this.pagination
      this.pagination.pageNo = pageNo + 1
      this.getEnterpriseList(true)
    },

    /**
     * @Author: maogangfeng
     * @Date: 2020-03-20 16:49:39
     * @Desc: 获取视频巡查页面企业列表搜索条件
     */
    async getEnterpriseConditions() {
      const { data = [] } = await http.getEnterpriseConditions()
      for (let index = 0; index < data.length; index++) {
        const info = data[index]
        this[info.attributesKey].labelType = info.attributesName
        info.dataList.forEach(scope => {
          this[info.attributesKey].list.push({
            labelId: scope.code,
            labelName: scope.content
          })
        })
      }
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-20 19:41:02
     * @Desc: 查询区域信息
     */
    async queryDutyRegion() {
      const { data } = await http.queryDutyRegion({
        projectId: this.$store.state.projectCode,
        regionCode: '330000'
      })
      data.forEach(region => {
        region.label = region.name
      })
      this.regionData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.enterprise-content-container {
  overflow: auto;
}
</style>
